import React from 'react';
import { ForgotPasswordForm } from '../components/auth/ForgotPasswordForm';

/**
 * Forgot Password page with two-column layout
 * Matches Login and Register page design
 */
const ForgotPassword: React.FC = () => {
  return (
    <div className="min-h-screen flex">
      {/* Left Column - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary-600 to-primary-700 p-12 flex-col justify-center items-center">
        <div className="max-w-lg text-center">
          {/* Logo */}
          <div className="flex items-center justify-center mb-8">
            <div className="bg-white rounded-full px-8 py-4 shadow-lg flex items-center justify-center">
              <img 
                src="/logo.png" 
                alt="Canvango" 
                className="h-12 w-auto"
              />
            </div>
          </div>
          
          {/* Heading */}
          <h2 className="text-white text-3xl font-bold mb-4 leading-tight">
            Reset Password Anda Dengan Mudah
          </h2>
          
          {/* Description */}
          <p className="text-primary-100 text-lg leading-relaxed">
            Kami akan mengirimkan link reset password ke email Anda. Proses cepat dan aman untuk mengamankan akun Anda.
          </p>
        </div>
      </div>

      {/* Right Column - Forgot Password Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-gray-50">
        <ForgotPasswordForm />
      </div>
    </div>
  );
};

export default ForgotPassword;
